import {
  type OrderGetOrderDetailsOrderItemReadDto,
  type OrderItemDetailsReadDto,
} from "@/config/apiClient";
import {
  OrderItemLogActionTypeEnum,
  OrderItemStatusEnum,
} from "@/config/apiClient.types";

export const isPostOrderEditionAvailable = (
  orderItem?: OrderGetOrderDetailsOrderItemReadDto | OrderItemDetailsReadDto
) => {
  return (
    !orderItem?.OrderLog.filter(
      (log) => log.actionType === OrderItemLogActionTypeEnum.CONFIRM_PROOF
    ).length &&
    orderItem?.status !== OrderItemStatusEnum.CANCELLED &&
    orderItem?.status !== OrderItemStatusEnum.DONE
  );
};
